export type QueryParamValue = string | number | boolean | string[] | number[] | boolean[];

/**
 * Serializes a params object into a query string, repeating the key once per array element
 * (`tags=a&tags=b`) instead of collapsing arrays into a single comma-joined value the way
 * `new URLSearchParams(obj)` does. Shared across API services that need array-valued filters.
 * @param params
 */
export function buildQueryString(params: Record<string, QueryParamValue | null | undefined> = {}): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => search.append(key, String(item)));
    } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      search.append(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}
